/* eslint-disable import/no-anonymous-default-export */
import React from 'react';
import { Link } from "react-router-dom";
import './NavigationBar.css';

export default (props: any) =>
    <div className="NavigationBar">
        {props.routes.slice(0, props.routes.length - 1).map((route: any) =>
            <div>
                <Link to={route.path()}>{route.label}</Link>
                <span>-</span>
            </div>
        )}
        <Link to={props.routes[props.routes.length - 1].path()}>{props.routes[props.routes.length - 1].label}</Link>
    </div>
